import {compositionEditorLimits} from '../constants/compositionEditorLimits';
import {LayerBox} from '../types/CompositionEditorAction';
import {ResizeHandle} from '../types/ResizeHandle';

const resizeEdge = (size: number, delta: number, shrinksFromStart: boolean, grows: boolean) => {
  if (shrinksFromStart) {
    return Math.max(compositionEditorLimits.minLayerSize, size - delta);
  }
  if (grows) {
    return Math.max(compositionEditorLimits.minLayerSize, size + delta);
  }
  return size;
};

/**
 * Applies a pointer delta (scene px) to a layer box through one of the eight resize handles.
 * Edges opposite to the dragged handle stay anchored.
 */
export const applyResizeHandle = (
  start: LayerBox,
  handle: ResizeHandle,
  dx: number,
  dy: number
): LayerBox => {
  const movesLeft = handle.includes('w');
  const movesTop = handle.includes('n');
  const width = resizeEdge(start.width, dx, movesLeft, handle.includes('e'));
  const height = resizeEdge(start.height, dy, movesTop, handle.includes('s'));

  return {
    x: movesLeft ? start.x + start.width - width : start.x,
    y: movesTop ? start.y + start.height - height : start.y,
    width,
    height,
  };
};
